document.addEventListener('DOMContentLoaded', function () {
  function enableHoverMenu() {
    if (window.matchMedia('(min-width: 750px)').matches) {
      document.querySelectorAll('header-menu details').forEach(function (details) {
        details.addEventListener('mouseenter', function () {
          details.setAttribute('open', '');
        });
        details.addEventListener('mouseleave', function () {
          details.removeAttribute('open');
        });
      });
    }
  }
  enableHoverMenu();
});